import { render } from "./EditSendToClipboardInfo.vue?vue&type=template&id=8e711750&scoped=true"
import script from "./EditSendToClipboardInfo.vue?vue&type=script&lang=js"
export * from "./EditSendToClipboardInfo.vue?vue&type=script&lang=js"

import "./EditSendToClipboardInfo.vue?vue&type=style&index=0&id=8e711750&scoped=true&lang=css"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e711750"]])

export default __exports__